module.exports = __webpack_public_path__ + "static/brandbox-pricingBG-branded-ab28dd217fc57d376b157be455d160ef.png";